<template>
	<div>
        <TrafficInfoWin v-show="false"
            v-on:loaded-traffic-info="loadedTrafficInfoHandle"
            ref="trafficInfoWin"></TrafficInfoWin>
	</div>    
</template>
<script>
import naverMapShareMixins from '@/stores/naver.map.share.mixin';
import { $_TYPE, $_WC } from '@/confs/common.const.js';
import { mapGetters } from "vuex";
import TrafficInfoWin from "@/views/realtime/SeoulmapTrafficInfoWin.vue"; 

export default {
	components: {
        TrafficInfoWin
    },
	data(){
		return {
			selectedAreaData: {},
			markerKey: 'seoulmap',
			subwayMarkerMap: {
			    '1': 'realtime_subway_1.png',
			    '2': 'realtime_subway_2.png',
			    '3': 'realtime_subway_3.png',
                '4': 'realtime_subway_4.png',
                '5': 'realtime_subway_5.png',
                '6': 'realtime_subway_6.png',
                '7': 'realtime_subway_7.png',
                '8': 'realtime_subway_8.png',
                '9': 'realtime_subway_9.png',
                '신분당선':'realtime_subway_11.png',
                '수인분당선': 'realtime_subway_10.png',
			},
		}
	},
	created(){
		this.$eventBus.$on("SeoulmapMapCtrl::loaded-seoulmap-data", (selectedAreaData) => {
		    this.selectedAreaData = selectedAreaData;
		});
	},
    watch: {
    	selectedAreaData: {
    	    immediate: false,
    	    handler(newVal, oldVal) {
    	        if(typeof newVal !== 'undefined') {
    	            this.showSubwayMarker();
    	        }  
    	    },
    	}
    },
    methods: {
        showSubwayMarker() {
            this.removeMarker(this.markerKey);
            
            // 버스
            if(typeof this.selectedAreaData.BUS_STN_STTS !== 'undefined') {
                let busList = this.selectedAreaData.BUS_STN_STTS;
                busList.forEach((bus) => {
                    bus.key = 'bus';
                    let imgFileNm = 'marker_103_c.png';
                    let markerData = {
                            markerKey: this.markerKey,
                            key: bus.BUS_STN_NM,
                            lttdVal: bus.BUS_STN_Y,
                            lgtdVal: bus.BUS_STN_X,
                    }
                    let sizeW = 21;
                    let sizeH = 28;
                    if($_WC.viewScale > 1) {
                        sizeW = 14;
                        sizeH = 21;
                    }
                    let busMarker = this.makeMarker(this.markerKey, markerData, function(event, data, marker) {
                        this.$refs.trafficInfoWin.setTrafficInfo(bus);
                        this.map.setCenter(new naver.maps.LatLng(bus.BUS_STN_Y, bus.BUS_STN_X));
                    }.bind(this), imgFileNm, '/img/marker/', sizeW * $_WC.viewScale, sizeH * $_WC.viewScale);
                });
                
                this.showMarkers(this.markerKey, true);
                // 현재 모든 마커를 seoulmap이라는 마커 키로 뿌리는 동작이므로, 클러스터링 할 수 없음
                // 클러스터링은 추가 요청사항이 오면 그때 진행.
                // this.showClusterMarkers(this.markerKey, true);
            }
            
            // 전기차 충전소
            if(typeof this.selectedAreaData.CHARGER_STTS !== 'undefined') {
                let cgList = this.selectedAreaData.CHARGER_STTS;
                cgList.forEach(function(cg) {
                    cg.key = 'cg';
                    let imgFileNm = 'marker_105.png';
                    let markerData = {
                            markerKey: this.markerKey,
                            key: cg.STAT_NM,
                            lttdVal: cg.STAT_Y,
                            lgtdVal: cg.STAT_X,
                    }
                    let sizeW = 21;
                    let sizeH = 28;
                    if($_WC.viewScale > 1) {
                        sizeW = 14;
                        sizeH = 21;
                    }
                    let pkMarker = this.makeMarker(this.markerKey, markerData, function(event, data, marker) {
                        this.$refs.trafficInfoWin.setTrafficInfo(cg);
                        this.map.setCenter(new naver.maps.LatLng(cg.STAT_Y, cg.STAT_X));
                    }.bind(this), imgFileNm, '/img/marker/', sizeW * $_WC.viewScale, sizeH * $_WC.viewScale);
                }.bind(this));
                
                this.showMarkers(this.markerKey, true);
            }
            
            // 따릉이
            if(typeof this.selectedAreaData.SBIKE_STTS !== 'undefined') {
                let sbikeList = this.selectedAreaData.SBIKE_STTS;
                sbikeList.forEach(function(sbike) {
                    sbike.key = 'sbike';
                    let imgFileNm = "marker_032_v.png";
                    let sizeW = 21;
                    let sizeH = 28;
                    if($_WC.viewScale > 1) {
                        sizeW = 14;
                        sizeH = 21;
                    }
                    let markerData = {markerKey: this.markerKey, key: sbike.SBIKE_SPOT_NM, lttdVal: sbike.SBIKE_Y, lgtdVal: sbike.SBIKE_X};
                    let marker = this.makeMarker(this.markerKey, markerData, function(event, data, marker){
                        this.$refs.trafficInfoWin.setTrafficInfo(sbike);
                        this.map.setCenter(new naver.maps.LatLng(sbike.SBIKE_Y, sbike.SBIKE_X));
                    }.bind(this), imgFileNm, '/img/marker/', sizeW * $_WC.viewScale, sizeH * $_WC.viewScale);
                    
                    this.addMarkerMap('seoulmap', marker);
                }.bind(this));
                
                this.showMarkers(this.markerKey, true);
            }
            
            // 지하철
            if(typeof this.selectedAreaData.SUB_STTS !== 'undefined') {
                let subList = this.selectedAreaData.SUB_STTS;
                subList.forEach(function(d) {
                    d.key = 'subway';
                    let imgFileNm = this.subwayMarkerMap[d.SUB_STN_LINE];
                    // 마커
                    let size = 28;
                    if($_WC.viewScale > 1) {
                        size = 22;
                    }
                    let markerData = {markerKey: this.markerKey, key: d.SUB_STN_NM, lttdVal: d.SUB_STN_Y, lgtdVal: d.SUB_STN_X};
                    let marker = this.makeMarker(this.markerKey, markerData, function(event, data, marker){
                        this.$refs.trafficInfoWin.setTrafficInfo(d);
                        this.map.setCenter(new naver.maps.LatLng(d.SUB_STN_Y, d.SUB_STN_X));
                    }.bind(this), imgFileNm, '/img/marker/', size * $_WC.viewScale, size * $_WC.viewScale);
                    
                    this.addMarkerMap('seoulmap', marker);
                    
                }.bind(this));
                
                this.showMarkers(this.markerKey, true);
            }
            
            // 주차장
            if(typeof this.selectedAreaData.PRK_STTS !== 'undefined') {
                let pkList = this.selectedAreaData.PRK_STTS;
                pkList.forEach(function(pk) {
                    pk.key = 'pk';
                    let imgFileNm = 'marker_36_2.png';
                    let markerData = {
                            markerKey: this.markerKey,
                            key: pk.PRK_NM,
                            lttdVal: pk.LAT,
                            lgtdVal: pk.LNG,
                    }
                    let size = 28;
                    if($_WC.viewScale > 1) {
                        size = 22;
                    }
                    let pkMarker = this.makeMarker(this.markerKey, markerData, function(event, data, marker) {
                        this.$refs.trafficInfoWin.setTrafficInfo(pk);
                        this.map.setCenter(new naver.maps.LatLng(pk.LAT, pk.LNG));
                    }.bind(this), imgFileNm, '/img/marker2/', size * $_WC.viewScale, size * $_WC.viewScale);
                }.bind(this));
                
                this.showMarkers(this.markerKey, true);
            }
            
            
            
        },
    	loadedTrafficInfoHandle: function(content){
    		this.openInfoWin(content);
    	},
    },
	mixins: [naverMapShareMixins],
};
</script>